import { useEffect, useState } from 'react';
import { courtAPI } from '../services/courtApi';

/** Fallback marketing si l’API n’est pas joignable. */
export const FALLBACK_PADEL_COURTS = {
  total: 11,
  indoor: 7,
  outdoor: 4,
};

export function formatPadelCourtsDetail({ total, indoor, outdoor }) {
  const t = Number(total) || 0;
  const i = Number(indoor) || 0;
  const o = Number(outdoor) || 0;
  return `${t} terrain${t > 1 ? 's' : ''} — ${i} indoor · ${o} outdoor`;
}

/**
 * Compteurs padel alignés sur l’admin (GET /api/courts/public/padel).
 * Ajouter / désactiver un terrain dans le super admin met à jour Contact, Home, etc.
 */
export default function usePadelCourtsSummary() {
  const [summary, setSummary] = useState(FALLBACK_PADEL_COURTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await courtAPI.getPublicPadelCourts();
        const raw = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
        if (cancelled || raw.length === 0) return;

        const indoor = raw.filter((c) => String(c.location || '').toLowerCase() === 'indoor').length;
        const outdoor = raw.filter((c) => String(c.location || '').toLowerCase() === 'outdoor').length;
        // Si un terrain n’a pas de location claire, on le compte quand même dans le total
        // mais indoor/outdoor ne reflète que les valeurs explicites.
        setSummary({
          total: raw.length,
          indoor,
          outdoor,
        });
      } catch {
        /* garde le fallback */
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return {
    ...summary,
    loading,
    detail: formatPadelCourtsDetail(summary),
    shortLabel: `${summary.total} terrain${summary.total > 1 ? 's' : ''} de padel`,
    subLabel: `${summary.indoor} indoor · ${summary.outdoor} outdoor`,
  };
}
